module.exports = __webpack_public_path__ + "static/media/gsNl3i_sm3.2fbefefd.png";